import { format, parseISO } from "date-fns";
import seLocale from "date-fns/locale/sv";

export const formatDateTime = (date: string) => {
  return format(parseISO(date), "yyyy-MM-dd HH:mm", {
    locale: seLocale,
  });
};
export const formatDateTimeSec = (date: string) => {
  return format(parseISO(date), "HH:mm:ss", {
    locale: seLocale,
  });
};
